<template>
  <div class="art1">
    <span style="font-family: 微軟正黑體;">
      <span style="font-size: 12pt;">結合台灣國寶級藝術</span>
      <span style="font-size: 12pt;">，</span>
      <span style="font-size: 12pt;">提升優質文化信仰</span>
      <span style="font-size: 12pt;">
        ，本殿義德館展出由台灣雕刻藝術大師陳正雄先生及「交趾陶保存修復技術」保存者林洸沂老師，融合現代的傳統宗教藝術，讓義德館更增添了幾分古雅的韻味。讓我們跟隨著大師的腳步，體驗台灣國寶級藝術精湛藝術工藝！
        <span lang="EN-US">
          <br />
          <br />
        </span>
      </span>
    </span>
    <span
      style="font-size: 12pt; font-family: 新細明體, serif; color: rgb(20, 24, 35); background-image: initial; background-attachment: initial; background-size: initial; background-origin: initial; background-clip: initial; background-position: initial; background-repeat: initial;"
      >★</span
    >
    <span style="font-family: 微軟正黑體;">
      <span
        style="font-size: 12pt; color: rgb(20, 24, 35); background-image: initial; background-attachment: initial; background-size: initial; background-origin: initial; background-clip: initial; background-position: initial; background-repeat: initial;"
        >&nbsp;展覽開放時間</span
      >
    </span>
    <span
      style="font-size: 12pt; font-family: 新細明體, serif; color: rgb(20, 24, 35); background-image: initial; background-attachment: initial; background-size: initial; background-origin: initial; background-clip: initial; background-position: initial; background-repeat: initial;"
      >：</span
    >
    <span style="font-family: 微軟正黑體;">
      <span
        style="font-size: 12pt; color: rgb(20, 24, 35); background-image: initial; background-attachment: initial; background-size: initial; background-origin: initial; background-clip: initial; background-position: initial; background-repeat: initial;"
        >每週日 早上</span
      >
      <span
        lang="EN-US"
        style="font-size: 12pt; color: rgb(20, 24, 35); background-image: initial; background-attachment: initial; background-size: initial; background-origin: initial; background-clip: initial; background-position: initial; background-repeat: initial;"
        >9:30</span
      >
      <span
        style="font-size: 12pt; color: rgb(20, 24, 35); background-image: initial; background-attachment: initial; background-size: initial; background-origin: initial; background-clip: initial; background-position: initial; background-repeat: initial;"
        >至</span
      >
      <span
        style="font-size: 12pt; color: rgb(20, 24, 35); background-image: initial; background-attachment: initial; background-size: initial; background-origin: initial; background-clip: initial; background-position: initial; background-repeat: initial;"
      ></span>
      <span
        style="font-size: 12pt; color: rgb(20, 24, 35); background-image: initial; background-attachment: initial; background-size: initial; background-origin: initial; background-clip: initial; background-position: initial; background-repeat: initial;"
        >下午</span
      >
      <span
        lang="EN-US"
        style="font-size: 12pt; color: rgb(20, 24, 35); background-image: initial; background-attachment: initial; background-size: initial; background-origin: initial; background-clip: initial; background-position: initial; background-repeat: initial;"
      >
        4:30
        <br />
        <br />
      </span>
    </span>
    <span
      style="font-size: 12pt; font-family: 新細明體, serif; color: rgb(20, 24, 35); background-image: initial; background-attachment: initial; background-size: initial; background-origin: initial; background-clip: initial; background-position: initial; background-repeat: initial;"
      >★ &nbsp;</span
    >
    <span style="font-family: 微軟正黑體;">
      <span
        style="font-size: 12pt; color: rgb(20, 24, 35); background-image: initial; background-attachment: initial; background-size: initial; background-origin: initial; background-clip: initial; background-position: initial; background-repeat: initial;"
        >作品欣賞</span
      >
      <span style="color: rgb(20, 24, 35); font-size: 16px;">：</span>
    </span>
    <span
      style="color: rgb(20, 24, 35); font-family: 新細明體, serif; font-size: 16px;"
    >
      <a
        href="https://www.facebook.com/media/set/?set=a.653418481427795.1073741853.416178818485097&amp;type=3"
        target="_blank"
      >
        <span style="font-family: 微軟正黑體;">義德館</span>
      </a>
    </span>
    <span style="font-family: 微軟正黑體;">
      <span style="color: rgb(20, 24, 35); font-size: 16px;"
        >&nbsp; &nbsp; &nbsp; &nbsp;</span
      >
    </span>
    <span
      style="color: rgb(20, 24, 35); font-family: 新細明體, serif; font-size: 16px;"
    >
      <a
        href="https://www.facebook.com/media/set/?set=a.652604244842552.1073741851.416178818485097&amp;type=3"
        target="_blank"
      >
        <span style="font-family: 微軟正黑體;">非洲巨型原木</span>
      </a>
    </span>
  </div>
</template>

<script>
export default {
  name: 'Art1',
  data() {
    return {
      page: this.$route.query.page,
    };
  },
  watch: {
    $route() {
      this.page = this.$route.query.page;
    },
  },
};
</script>

<style scoped></style>
